import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { v4 as uuidv4 } from "uuid";

export const xBtmidHeaderInterceptor = (config: InternalAxiosRequestConfig) => {
    config.headers.set("X-BTMID", uuidv4().substring(0, 24));
    return config;
};

export const addXBtmidHeaderInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(xBtmidHeaderInterceptor);
};
